import { useState } from "react";
import { Card, CardContent, Container, Grid } from "@material-ui/core";
import FilterCard from "components/_refactor/filter-card";
import PeriodField from "components/_refactor/fields/period-field";
import StructureFields from "components/_refactor/fields/structure";
import HeaderClientes from "components/_refactor/headers/clients";
import { IsMobile } from "utils/is-mobile";
import BigNumberCard from "components/_refactor/card/big-number";
import TableAcompanhamentoAtendimento from "./components/table";
import Api from "lib/api/httpRequestHelper";
import InfoDialog from "./components/dialog-info";
import moment from "moment";

const dataHoje = new Date().toISOString().slice(0, 10);
const data30DiasAtras = moment(dataHoje)
  .subtract(30, "days")
  .format("YYYY-MM-DD");

export default function AcompanhamentoAtendimento() {
  const [structureFilters, setStructureFilters] = useState({});
  const [periodo, setPeriodo] = useState(null);
  const [periodoInicial, setPeriodoInicial] = useState(dataHoje);
  const [periodoFinal, setPeriodoFinal] = useState(data30DiasAtras);
  const [clearFilters, setClearFilters] = useState(false);
  const [cardsData, setCardsData] = useState({
    demandas: 0,
    resolvidos: 0,
    pendentes: 0,
  });
  const [servicesList, setServicesList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [loadingCards, setLoadingCards] = useState(false);
  const [structureLoading, setStructureLoading] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const isMobile = IsMobile();
  const itemSM = isMobile ? 12 : 4;

  console.log("structureFilters", structureFilters);

  const handleClearFilters = () => {
    setClearFilters(true);
    setPeriodo(null);
    setPeriodoInicial(null);
    setPeriodoFinal(null);
  };

  const handleSearch = async ({ status }) => {
    setSearching(true);
    handleSearchTotais();
    try {
      const response = await Api.get(
        "tiket-detail",
        "omnireport",
        `?idGrupoEconomico=${structureFilters?.idGrupoEconomico || "TODOS"}` +
          `&idLoja=${structureFilters?.idLoja || "TODAS"}` +
          `&status=${status}` +
          `&dtIni=${periodoInicial}&dtFim=${periodoFinal}`,
        true
      );
      setServicesList(response?.Result?.ListaChamados);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setSearching(false);
  };

  const handleSearchTotais = async () => {
    setLoadingCards(true);
    try {
      const response = await Api.get(
        "tiket-total",
        "omnireport",
        `?idGrupoEconomico=${structureFilters?.idGrupoEconomico || "TODOS"}` +
          `&idLoja=${structureFilters?.idLoja || "TODAS"}` +
          `&dtIni=${periodoInicial}&dtFim=${periodoFinal}`,
        true
      );
      setCardsData({
        demandas: response?.Result?.TotalDemandas || 0,
        resolvidos: response?.Result?.TotalResolvido || 0,
        pendentes: response?.Result?.TotalPendente || 0,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingCards(false);
  };

  const CARDS_INFO = [
    {
      title: "Demandas",
      value: cardsData.demandas,
      loading: loadingCards,
      onClick: () => {
        handleSearch({ status: "TODOS" });
      },
    },
    {
      title: "Resolvidos",
      value: cardsData.resolvidos,
      loading: loadingCards,
      onClick: () => {
        handleSearch({ status: "FINALIZADO" });
      },
    },
    {
      title: "Pendentes",
      value: cardsData.pendentes,
      loading: loadingCards,
      onClick: () => {
        handleSearch({ status: "ABERTO" });
      },
    },
  ];

  return (
    <div>
      <HeaderClientes
        section="Acompanhamento de Atendimento"
        subsection="Serviços"
      />
      <Container maxWidth={false} style={{ marginTop: "-4rem" }}>
        <FilterCard
          handleSearch={() => handleSearch({ status: "TODOS" })}
          disabled={searching || structureLoading.length > 0}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <StructureFields
            clearFilters={clearFilters}
            onStructureFieldsChange={setStructureFilters}
            disableAll={searching}
            onStructureFieldsLoad={setStructureLoading}
            handleSearch={() => handleSearch({ status: "TODOS" })}
            hideFields={["channel", "representative", "brand"]}
            fieldsOrder={["economicGroup", "store"]}
          />
          <Grid item xs={periodo?.value === "Outros" ? "12" : "3"}>
            <PeriodField
              label="Período"
              value={periodo}
              onChange={setPeriodo}
              initialDate={periodoInicial}
              finalDate={periodoFinal}
              setInitialDate={setPeriodoInicial}
              setFinalDate={setPeriodoFinal}
              disabled={searching}
              required={false}
            />
          </Grid>
        </FilterCard>

        <Card>
          <CardContent>
            <Grid container spacing={2}>
              {CARDS_INFO.map((card, index) => (
                <Grid item xs={itemSM} key={index}>
                  <BigNumberCard
                    title={card.title}
                    value={card.value}
                    loading={card.loading}
                    onClick={card.onClick}
                  />
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        <TableAcompanhamentoAtendimento
          data={servicesList}
          loading={searching}
          onRowClick={(row) => setSelectedRow(row)}
        />
      </Container>
      {selectedRow && (
        <InfoDialog onClose={() => setSelectedRow(null)} row={selectedRow} />
      )}
    </div>
  );
}
